import React from 'react';
import { SocialLinksJumbotron } from 'Roblox';
import metadataConstants from '../constants/metadataConstants';

const { SocialLinkJumbotronType } = SocialLinksJumbotron;

export const AboutTab = (): JSX.Element => {
  const { universeId = '' } = metadataConstants.metadataData() || {};
  const universeNumber = parseInt(universeId, 10);

  return <SocialLinksJumbotron type={SocialLinkJumbotronType.Game} targetId={universeNumber} />;
};

export default AboutTab;
